import styled from 'styled-components';
import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';
import { Image } from 'ui/Image';

export const Icon = styled(Image).attrs(props => ({
  dir: '/icons',
  objectFit: 'fill',
}))`
  width: 17px;
  min-width: 17px;
  height: 17px;
  ${whiteTheme.media.tablet} {
    width: 21px;
    height: 21px;
  }
`;

export const ButtonWrap = styled.button.attrs(() => ({ type: 'button' }))`
  display: flex;
  flex-wrap: wrap;
  margin-left: 5px;
  margin-right: 5px;
  cursor: pointer;
  ${whiteTheme.media.tabletS} {
    margin-left: 3px;
    margin-right: 3px;
    /* margin-top: 6px; */
  }
`;
